import { render, staticRenderFns } from "./AccountDashboard.html?vue&type=template&id=e5bd457a&scoped=true&"
import script from "./AccountDashboard.ts?vue&type=script&lang=ts&"
export * from "./AccountDashboard.ts?vue&type=script&lang=ts&"
import style0 from "./_dashboard.scss?vue&type=style&index=0&id=e5bd457a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bd457a",
  null
  
)

export default component.exports